import { Box, Typography, useTheme } from "@mui/material";
import PropTypes from "prop-types";

const SectionHeader = ({ stepNumber, title }) => {
  const theme = useTheme();
  return (
    <Box display="flex" alignItems="center" gap={1.5} mb={1.5}>
      <Box
        sx={{
          width: 26,
          height: 26,
          borderRadius: "50%",
          backgroundColor: theme.palette.info.main,
          color: theme.palette.common.white,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: 13,
          fontWeight: 700,
          flexShrink: 0,
        }}
      >
        {stepNumber}
      </Box>
      <Typography
        variant="subtitle1"
        sx={{
          fontWeight: 700,
          fontSize: "16px",
        }}
      >
        {title}
      </Typography>
    </Box>
  );
};

SectionHeader.propTypes = {
  stepNumber: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
    .isRequired,
  title: PropTypes.string.isRequired,
};

export default SectionHeader;
